import Reflux from "reflux";
import { singletonActions, singletonStore } from "logic/singleton";
import OriginalStreamsStore from "stores/streams/StreamsStore";
import { SessionActions } from "stores/sessions/SessionStore";
export const StreamsActions = singletonActions("views.Streams", () => Reflux.createActions(["refresh"]));
export const StreamsStore = singletonStore(
  "views.Streams",
  () => Reflux.createStore({
    listenables: [StreamsActions],
    streams: [],
    init() {
      this.refresh();
      SessionActions.logout.completed.listen(() => this.clear());
    },
    getInitialState() {
      return this._state();
    },
    refresh() {
      OriginalStreamsStore.listStreams().then((result) => {
        this.streams = result;
        this._trigger();
      });
    },
    clear() {
      this.streams = [];
      this._trigger();
    },
    _state() {
      return {
        streams: this.streams
      };
    },
    _trigger() {
      this.trigger(this._state());
    }
  })
);
